export * from './appointment-entity.model';
export * from './appointment-independent-contact.model';
export * from './appointment-listing.model';
export * from './appointment-listing.viewmodel';
export * from './appointment-participant.model';
export * from './appointment.model';
export * from './appointment.parameter';
export * from './appointment-quick-update.model';


// WEBPACK FOOTER //
// ./src/models/appointment/index.ts